import React, { FC, useEffect } from 'react';
import { t } from '@whitesharx/starfall-frontend-ttranslate';
import { modalContentStyles, headerStyles, closeButtonStyles, pictureContainerStyles, linkStyles } from '../styles.css';
import { buttonStyles } from '~/src/screens/Guest/styles.css';
import { imageStyles, textStyles, titleStyles } from './styles.css';
import { buildDeeplink } from '../utils';
import { isIOSBrowser } from '~/src/constants/env';

type DeeplinkModalFirstProps = {
  onRequestClose: () => void;
  onClick: () => void;
};

const DeeplinkModalFirst: FC<DeeplinkModalFirstProps> = ({ onRequestClose, onClick }) => {
  useEffect(() => {
    fetch(buildDeeplink('view', isIOSBrowser ? 'ios' : 'android', 'popup_1'), { mode: 'no-cors' });
  }, []);

  return (
    <div className={modalContentStyles}>
      <div className={headerStyles}>
        <span className={titleStyles}>{t('deeplink-text.title')}</span>

        <span aria-label="close-deeplink" role="button" onClick={onRequestClose} className={closeButtonStyles}>
          <svg viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg" width="14px" height="14px" fill="#5F525D">
            <path d="M12,14a2,2,0,0,1-1.41-.59L7,9.83,3.41,13.41a2,2,0,0,1-2.82,0,2,2,0,0,1,0-2.82L4.17,7,.59,3.41A2,2,0,0,1,.59.59a2,2,0,0,1,2.82,0L7,4.17,10.59.59a2,2,0,0,1,2.82,0,2,2,0,0,1,0,2.82L9.83,7l3.58,3.59A2,2,0,0,1,12,14Z" />
          </svg>
        </span>
      </div>

      <picture className={pictureContainerStyles}>
        <source srcSet="/assets/images/deeplink-install.webp" type="image/webp" />
        <img
          alt="install"
          src="/assets/images/deeplink-install.png"
          // @ts-expect-error
          fetchpriority="high"
          className={imageStyles}
        />
      </picture>

      <div className={textStyles}>{t('deeplink-text.variant1')}</div>

      <a
        target="_blank"
        onClick={onClick}
        href={buildDeeplink('click', isIOSBrowser ? 'ios' : 'android', 'popup_1')}
        aria-label="download"
        className={`${buttonStyles} ${linkStyles}`}
      >
        {t('button.download-now')}
      </a>
    </div>
  );
};

export default DeeplinkModalFirst;
